import { sparql } from '@tpluscode/rdf-string';
import { concat } from "../TemplateResult.mjs";
// eslint-disable-next-line no-use-before-define
export default ((strings, values) => ({
  quadData: sparql(strings, ...values),

  DATA(strings, ...values) {
    return { ...this,
      quadData: concat(this.quadData, strings, values)
    };
  }

}));